import { createTheme } from '@mantine/core';

/** Light, high-contrast office theme (D11): dark blue actions, clear focus ring on every control. */
export const theme = createTheme({
  primaryColor: 'blue',
  primaryShade: 8,
  focusRing: 'always',
  defaultRadius: 'sm',
});
